import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { AppException } from '../exceptions/app.exception';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ErrorManagerService } from '../../services/error-manager.service';

@Component({
	selector: 'app-modal-generic',
	imports: [FormsModule],
	templateUrl: './modal-generic.component.html',
	styleUrl: './modal-generic.component.css',
})
export class ModalGenericComponent implements OnInit{
	email: string = '';

	private readonly authService = inject(AuthService);
  private readonly errorManagerService = inject(ErrorManagerService);
    private readonly destroy$ = new Subject<void>();
  
	emailInviataConSuccesso = false;
	erroreInvioEmail = false;

	  errors: AppException = { errorCode: 0, errorMessage: '' } as AppException;
    errorSubscription!: Subscription;

    ngOnInit() {
      this.errorManagerService
        .getError$()
        .pipe(takeUntil(this.destroy$))
        .subscribe((error) => {
          this.errors = error;
        });
    }

	submit() {
		this.authService.resendConfirmRegister(this.email).subscribe({
			next: (res) => {
				this.emailInviataConSuccesso = true;
				this.erroreInvioEmail = false;
			},
			error: (err) => {
				this.erroreInvioEmail = true;
				this.emailInviataConSuccesso = false;
				console.error("Errore durante l'invio dell'email:", err);
			},
		});
	}
}
